import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45b3e872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "captcha-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "captchaCanvas",
  width: "200",
  height: "50"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reload" }, "⟳", -1))
const _hoisted_4 = [
  _hoisted_3
]

import { onMounted } from "vue";


const __default__ = { name: "ReCaptcha" };


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["captcha-updated"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

let captchaText = "";

const generateRandomString = (length: number) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const drawCaptcha = () => {
  const canvas = document.getElementById("captchaCanvas") as HTMLCanvasElement;
  const context = canvas.getContext("2d");
  if (context) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    captchaText = generateRandomString(6);
    context.fillStyle = "#000";
    context.font = "24px Arial";
    context.fillText(captchaText, 50, 30);
    context.strokeStyle = "#A9A9A9";
    context.lineWidth = 1;
    for (let i = -canvas.height; i < canvas.width; i += 10) {
      context.beginPath();
      context.moveTo(i, 0);
      context.lineTo(i + canvas.height, canvas.height);
      context.stroke();
    }
    for (let i = 0; i < canvas.width + canvas.height; i += 10) {
      context.beginPath();
      context.moveTo(i, 0);
      context.lineTo(i - canvas.height, canvas.height);
      context.stroke();
    }
    emit('captcha-updated', captchaText);
  }
};

const refreshCaptcha = () => {
  drawCaptcha();
};

onMounted(() => {
  drawCaptcha();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      type: "button",
      class: "refresh-captcha",
      onClick: refreshCaptcha
    }, _hoisted_4)
  ]))
}
}

})